import React, { memo } from "react";
import { Handle, Position } from "@xyflow/react";
import NodeWrapper from "./NodeWrapper";
import useHandleConnected from "./useHandleConnected";
import { CallMerge } from "@mui/icons-material";

/**
 * Merge Node — Unir 2+ caminhos em um unico caminho.
 *
 * data.mergeMode: "waitAll" | "firstOnly"
 *   - waitAll: aguarda todos os inputs chegarem antes de continuar
 *   - firstOnly: continua assim que o primeiro input chegar
 * data.inputCount: number (2-4) — quantidade de entradas
 *
 * Saida: handle "a" (default)
 */
const INPUT_COLORS = ["#1565C0", "#7B1FA2", "#00695C", "#E65100"];

const MergeNode = memo(({ id, data, isConnectable, selected }) => {
  const getHandleClass = useHandleConnected(id);
  const mode = data?.mergeMode || "waitAll";
  const inputCount = Math.min(Math.max(data?.inputCount || 2, 2), 4);

  return (
    <NodeWrapper
      id={id}
      data={data}
      icon={<CallMerge />}
      title="Unir Caminhos"
      color="#00695C"
      bgColor="#E0F2F1"
      isConnectable={isConnectable}
      selected={selected}
      minWidth={200}
    >
      {/* Inputs indicators */}
      <div style={{ position: "relative" }}>
        {Array.from({ length: inputCount }).map((_, i) => (
          <div key={i} style={{
            display: "flex", alignItems: "center", gap: 6,
            position: "relative", paddingLeft: 4, marginBottom: 5,
          }}>
            <Handle
              type="target"
              position={Position.Left}
              id={`merge_in_${i}`}
              className={getHandleClass("target", `merge_in_${i}`)}
              style={{
                position: "absolute", top: "50%", left: -13,
                transform: "translateY(-50%)",
                cursor: "crosshair",
              }}
              isConnectable={isConnectable}
            />
            <span style={{
              fontSize: 10, fontWeight: 600,
              color: INPUT_COLORS[i],
              background: "#fff",
              border: `1px solid ${INPUT_COLORS[i]}30`,
              borderRadius: 4,
              padding: "1px 8px",
            }}>
              Entrada {i + 1}
            </span>
          </div>
        ))}
      </div>

      {/* Mode badge */}
      <div style={{
        display: "inline-block",
        background: mode === "waitAll" ? "#00695C" : "#F57C00",
        color: "#fff",
        borderRadius: 4,
        padding: "2px 8px",
        fontSize: 10,
        fontWeight: 700,
        marginTop: 4,
      }}>
        {mode === "waitAll" ? "Aguardar todos" : "Primeiro que chegar"}
      </div>
    </NodeWrapper>
  );
});

MergeNode.displayName = "MergeNode";
export default MergeNode;
